import { colorsList } from "../../data/colorsList";

export const mainBox = () => {
  return {
    padding: 5,
    width: 180,
  };
};

export const titleStyle = () => {
  return {
    width: "100%",
    textAlign: "left",
    color: colorsList.blue,
    fontWeight: "bold",
    marginBottom: 3,
  };
};

export const inputStyle = (style) => {
  let temp = {
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: colorsList.white,
    padding: 5,
    borderRadius: 10,
    border: `solid 2px ${colorsList.darkGrey}`,
    cursor: "pointer",
    fontSize: 18,
    textWrap: "nowrap",
    ...style,
  };
  return temp;
};
